import { gql } from '@apollo/client';

export default gql`
  mutation updateVoucher(
    $voucherAlias: String!
    $reason: String!
    $active: Boolean
    $recipientEmail: String
    $salesPeriodEnd: String
    $externalReferencesDates: ExternalReferencesDates
  ) {
    updateVoucher(
      voucherAlias: $voucherAlias
      reason: $reason
      active: $active
      recipientEmail: $recipientEmail
      salesPeriodEnd: $salesPeriodEnd
      externalReferencesDates: $externalReferencesDates
    ) {
      status
      customerEmail
    }
  }
`;
